export default function createMenuPalette(theme, current, base) {
    return {
        menu: {
            attachment: {
                backgroundColor: base.background,
                borderColor: base.gray[200],
                label: {
                    borderColor: base.gray[200],
                },
            },
            label: {
                color: base.gray[600],
            },
            item: {
                icon: {
                    color: current[500],
                },
                link: {
                    hover: {
                        backgroundColor: base.gray[100],
                    },
                    active: {
                        hover: {
                            backgroundColor: current[100],
                        },
                    },
                },
                active: {
                    color: current[500],
                    backgroundColor: current[50],
                },
            },
        },
    };
}
//# sourceMappingURL=menu.js.map